import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
  transform(time: string): string {
    if (!time) return '';

    const [hours, minutes] = time.split(':');
    const parsedHours = parseInt(hours, 10);
    const parsedMinutes = parseInt(minutes, 10);

    if (parsedHours === 0 && parsedMinutes < 60) {
      return `${parsedMinutes}min`;
    } 
    if (parsedHours === 0 && parsedMinutes === 60) {
      return "";
    } 

    if (parsedHours > 0 && parsedMinutes === 0) {
      return `${parsedHours}hr`;
    } 
    else {
      return `${parsedHours}hr ${parsedMinutes}min`;
    }
  }
}
